// @flow
import React from "react";
import TwentyFourSevenSvg from "../../../svg/qicons/twentyFourSeven.svg";
import type { IconSizes } from "../../../types/Icons";
import getSizeClass from "../../../helpers/getIconSizeClassname";

type Props = {
  size: IconSizes
};

const TwentyFourSeven = ({ size = "1.5x" }: Props) => {
  const sizeClass = getSizeClass(size);

  return <TwentyFourSevenSvg className={sizeClass} />;
};

export default TwentyFourSeven;
